import React from "react";
import { Link } from "react-router-dom";
import footerFlags from "../assets/footer-flags.svg";
import { contactPageEnabled } from "../utils/featureFlags";
import { ObfuscatedEmail } from "./ObfuscatedEmail";

export const Footer: React.FC = () => {
    const currentYear: number = new Date().getFullYear();

    const linkClass = "link link-hover text-sm md:text-base text-white transition-colors";

    return (
        <footer className="w-full bg-emerald-700 py-10 px-6 md:px-16 text-sm md:text-base text-white border-t border-emerald-600">
            <div className="container mx-auto flex flex-col gap-6">
                {/* Acknowledgement of Country — full width */}
                <div className="flex flex-col sm:flex-row sm:items-start gap-3 sm:gap-4 pb-6 border-b border-white/20">
                    <img
                        src={footerFlags}
                        alt="Aboriginal, Torres Strait Islander, and Progress Pride flags"
                        className="h-10 w-auto shrink-0"
                    />
                    <p className="text-sm md:text-base leading-relaxed">
                        We acknowledge the Wurundjeri Woi Wurrung people of the Eastern Kulin Nation as the Traditional
                        Custodians of the land on which we work in Melbourne. We pay our respects to Elders past and present.
                    </p>
                </div>

                {/* Bottom row: nav (left) + inclusion & copyright (right) */}
                <div className="flex flex-col gap-6 md:flex-row md:justify-between md:gap-12">
                    <nav
                        aria-label="Footer"
                        className="flex flex-wrap gap-x-6 gap-y-3 content-start md:shrink-0"
                    >
                        <Link to="/about" className={linkClass}>About</Link>
                        <Link to="/faq" className={linkClass}>FAQ</Link>
                        <Link to="/partners-sponsors" className={linkClass}>Green Solutions</Link>
                        {contactPageEnabled ? (
                            <Link to="/contact" className={linkClass}>Contact</Link>
                        ) : (
                            <ObfuscatedEmail
                                email="support@labzero.eco"
                                displayText="Contact"
                                showCopyIcon={false}
                                className={linkClass}
                            />
                        )}
                        <Link to="/terms" className={linkClass}>Terms</Link>
                        <Link to="/privacy" className={linkClass}>Privacy</Link>
                    </nav>

                    <div className="flex flex-col gap-4 md:flex-1 md:max-w-2xl">
                        <p className="text-sm md:text-base leading-relaxed">
                            We are committed to fostering an inclusive community that celebrates LGBTQIA+ identities
                            and diversity in all its forms.
                        </p>
                        <p className="text-xs md:text-sm font-mono text-right">
                            © Copyright {currentYear} <span className="logo-font">LAB ZER0</span> Pty Ltd. All rights reserved.
                        </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};
